import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MultiSelectTree } from "@progress/kendo-react-dropdowns";
import {
  fetchDataProducts,
  setFilterDataProducts,
} from "../../store/app/DataQualityStatus/DataQualitySlice";
import useMultiSelectTree from "../hooks/useMultiSelectTree";

const DataProductTreeSelector = () => {
  const dispatch = useDispatch();

  const dataProducts = useSelector((state) => state.dataQualityReducer.dataProducts);
  const stateValue = useSelector((state) => state.dataQualityReducer.filterDataProducts);

  const transformData = useCallback((inputArray) => {
    return inputArray.reduce((acc, item) => {
      const parentText = item.domain_description;
      const parentId = item.domain_id;
      if (!parentText || parentId === undefined) return acc;

      let parent = acc.find((g) => g.text === parentText && g.id === parentId);
      if (!parent) {
        parent = { text: parentText, id: parentId, items: [] };
        acc.push(parent);
      }
      if (item.productId && item.productName) {
        parent.items.push({ text: item.productName, id: item.productId });
      }
      return acc;
    }, []);
  }, []);

  useEffect(() => {
    dispatch(fetchDataProducts());
  }, [dispatch]);

  const { treeData, value, onChangeTree, onExpandChange, fields, getTags } =
    useMultiSelectTree({
      rawData: dataProducts,
      stateValue,
      urlParamKey: "dataproducts",
      transformData,
      setFilterAction: setFilterDataProducts,
      selectionLabel: "data products",
    });


  return (
    <MultiSelectTree
      id="multiSelectTreeDataProducts"
      className="form-select-kendo"
      autoclose={true}
      data={treeData}
      value={value}
      onChange={onChangeTree}
      textField="text"
      dataItemKey={fields.dataItemKey}
      checkField={fields.checkField}
      checkIndeterminateField={fields.checkIndeterminateField}
      expandField={fields.expandField}
      subItemsField={fields.subItemsField}
      onExpandChange={onExpandChange}
      adaptive={true}
      size="large"
      tags={getTags()}
    />
  );
};

export default DataProductTreeSelector;
